import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/oppeningClosingBox';

import CloseBox from './CloseBox';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.oppeningClosingBox,
        sales_open_box: state.sales.openCashBox,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(CloseBox);
